module.exports = __webpack_public_path__ + "media/ileitis.e2621a57.wav";